"use client";
import { Suspense, type ReactNode } from "react";

type Props = {
  children: ReactNode;
  fallback?: ReactNode;
};

export default function ClientSuspense({ children, fallback }: Props) {
  return (
    <Suspense fallback={fallback ?? <div className="p-6 text-center">Loading...</div>}>
      {children}
    </Suspense>
  );
}
